var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWidgetDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 160,
    viewBox: "0 0 854 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21252_122564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854 0.299988H0V160.3H854V0.299988Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M854 81.5V160.3H0V72.7C260.7 70.1 613.1 73.4 854 81.5Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M726.8 111.5C687.7 130.3 583.5 147.5 458.6 160.3H0V0.299988H302.1C464 5.99999 621.7 18.8 688.8 35.7C814.7 67.3 735.1 107.5 726.8 111.5Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M321.1 103.6C273.3 126.6 167.5 147.2 41.9 160.3H0V0.299988H73.7C159.2 6.09999 233.5 15.4 283 27.8C408.9 59.4 329.4 99.6 321.1 103.6Z",
    className: "illustration_primary-lightest"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21252_122564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWidgetDefault);
export default __webpack_public_path__ + "static/media/BackgroundWidgetDefault.8d392903.svg";
export { ForwardRef as ReactComponent };